export default __webpack_public_path__ + "static/media/hht2_ep1_speaking_03.532c4507.png";